import { render, staticRenderFns } from "./VehiclePageSpecifications.vue?vue&type=template&id=2a82e2b1&"
import script from "./VehiclePageSpecifications.vue?vue&type=script&lang=js&"
export * from "./VehiclePageSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports